import type { WireArticleBlock } from '../../../api/types'
import { PortionMark } from '../common/PortionMark'

type Block = Extract<WireArticleBlock, { type: 'section-marker' }>

const SECTION_LABELS: Record<Block['sectionType'], string> = {
  'summary':             'Key Judgments',
  'scope-note':          'Scope Note',
  'methodology-note':    'Methodology Note',
  'tradecraft-summary':  'Tradecraft Summary',
  'for-additional-info': 'For Additional Information',
  'appendix':            'Appendix',
}

export function SectionMarkerBlock({ block }: { block: Block }) {
  return (
    <div className="mb-2 mt-6 border-t-2 border-accent-primary-line pt-4">
      <p className="article-section-label text-accent-primary-fg">
        <PortionMark classification={block.classification} disseminationControls={block.disseminationControls} />
        {SECTION_LABELS[block.sectionType] ?? block.sectionType.replace(/-/g, ' ')}
      </p>
    </div>
  )
}
